import dotNotationToBracketNotation from "./helpers/dotNotationToBracketNotation";

let i = 0;

const salutationMapping = {
    'M': 'Herr',
    'W': 'Frau',
    'X': ''
}

const validateForm = (form, isGroupRegistration = false) => {
    const formIsValid = form.checkValidity()

    let notifications = [];
    let invalidFields = [];
    let validFields = [];

    //check if attendees are added
    if (isGroupRegistration && form.querySelectorAll('#attendee-list>div').length === 0) {
        notifications.push('Bitte Teilnehmer hinzufügen');
    }

    // Get required fields and check if they are empty
    // In a group registration, we only check registration fields, as attendee fields are managed by validateAttendee
    form.querySelectorAll('.registration-field' + (isGroupRegistration ? '' : ', .attendee-field'))
        .forEach((field) => {
            if (field.validity.valid) {
                delete invalidFields[field];
                validFields.push(field);
            } else {
                invalidFields.push(field);
            }
        })

    invalidFields.filter((field) => ['INPUT', 'SELECT'].indexOf(field.tagName) > -1).forEach((field) => {
        field.classList.add('invalid');
        const validityErrors = []
        if (field.validity.valueMissing) validityErrors.push('Die Eingabe ist notwendig.');
        if (field.validity.patternMismatch) validityErrors.push('Die Eingabe entspricht nicht der Vorgabe.');
        if (field.validity.tooShort) validityErrors.push('Die Eingabe ist zu kurz');
        if (field.validity.tooLong) validityErrors.push('Die Eingabe ist zu lang');
        const errorHint = field.parentElement.querySelector('.form__group__error')
        if (errorHint && validityErrors.length > 0) {
            errorHint.innerHTML = validityErrors.join('<br>');
        }
    })

    validFields.forEach((field) => {
        field.classList.remove('invalid')
        const errorHint = field.parentElement.querySelector('.form__group__error')
        if (errorHint) {
            errorHint.innerHTML = '';
        }
    })

    return {
        valid: (invalidFields.length + notifications.length) === 0 && formIsValid,
        notifications,
        invalidFields
    };
}

const addAttendee = (form) => {
    if (!validateAttendee(form)) {
        return;
    }
    const groupRegistrationForm = form.querySelector('form.group_registration');
    const a = form.querySelector("#attendee-list");
    const genderField = groupRegistrationForm.querySelector('[name="attendee[gender]"]')
    const firstNameField = groupRegistrationForm.querySelector('[name="attendee[name][firstName]"]')
    const lastNameField = groupRegistrationForm.querySelector('[name="attendee[name][lastName]"]')
    const dateOfBirthField = groupRegistrationForm.querySelector('[name="attendee[dateOfBirth]"]')
    const emailField = groupRegistrationForm.querySelector('[name="attendee[email]"]')
    const phoneNumberField = groupRegistrationForm.querySelector('[name="attendee[phoneNumber]"]')
    const staffNumberField = groupRegistrationForm.querySelector('[name="attendee[staffNumber]"]')
    const businessUnitField = groupRegistrationForm.querySelector('[name="attendee[businessUnit]"]')
    const customFields = groupRegistrationForm.getElementsByClassName('attendee-field--custom');
    const customFieldsArray = [...customFields];
    const reducedCustomFieldsArray = customFieldsArray.reduce((result, field) => {
        result[field.dataset.fieldIdentifier] = (field.type === 'checkbox' && field.checked === false) ? '' : field.value;
        return result
    }, {});

    let jsonObject = {
        gender: genderField?.value ?? null,
        name: {
            firstName: firstNameField?.value,
            lastName: lastNameField?.value,
        },
        dateOfBirth: dateOfBirthField ? dateOfBirthField.value : '',
        staffNumber: staffNumberField ? staffNumberField.value : '',
        businessUnit: businessUnitField ? businessUnitField.value : '',
        email: emailField ? emailField.value : '',
        phoneNumber: phoneNumberField ? phoneNumberField.value : '',
        customFields: reducedCustomFieldsArray || ''
    }

    let input = document.createElement("INPUT");
    input.setAttribute("id", "attendee" + i++);
    input.setAttribute("type", "hidden");
    input.setAttribute("name", "attendees[]");
    input.setAttribute("value", JSON.stringify(jsonObject));

    let cardNode = document.createElement("DIV");
    cardNode.classList.add('card-list__item');

    let bt = document.createElement('BUTTON')
    bt.classList.add('card-list__item__btn-close');
    bt.appendChild(document.createTextNode(""))
    bt.setAttribute('type', 'button')
    bt.setAttribute('onClick', "event.target.parentNode.remove()")
    cardNode.appendChild(input);

    let additionalFields = customFieldsArray.reduce((result, node) => {
        const label = node.parentElement.querySelector(`label[for="${node.getAttribute('id')}"]`)?.innerText
        result[label] = ((node.type === 'checkbox' && node.checked === false) ? 'nein' : node.value)
        return result
    }, {})

    const fields = {
        'name': ((jsonObject.gender ? salutationMapping[jsonObject.gender] : '') + ' ' + jsonObject.name.firstName + ' ' + jsonObject.name.lastName).trim(),
        'dateOfBirth': jsonObject.dateOfBirth,
        'staffNumber': jsonObject.staffNumber,
        'businessUnit': jsonObject.businessUnit,
        'email': jsonObject.email,
        'phoneNumber': jsonObject.phoneNumber,
        ...additionalFields
    }

    Object.keys(fields).forEach((fieldKey) => {
        const fieldNode = document.createElement('DIV');
        const fieldValue = fields[fieldKey];
        const fieldName = fieldKey.replace(/[^\w]/gi, '')
        const isCustom = additionalFields.hasOwnProperty(fieldKey)

        if (fieldValue && fieldValue !== '') {
            const additionalClass = 'card-list__item__' + fieldName;
            fieldNode.classList.add('card-list__item__field');
            fieldNode.classList.add(additionalClass);

            let content = ''
            if (isCustom) {
                fieldNode.classList.add('card-list__item__customField')
                // If we have a custom field, we prepend the label in addition
                content = fieldKey + ": "
            }
            content += fieldValue

            fieldNode.appendChild(document.createTextNode(content))
            cardNode.appendChild(fieldNode);
        }
    })

    cardNode.appendChild(bt);
    a.appendChild(cardNode);
    reset(form);
}


const validateAttendee = (form) => {
    let invalidFields = [];
    let validFields = [];
    let required = form.querySelectorAll('.attendee-field[data-validation="required"]');
    required.forEach((field) => {
        if (field.value === '') {
            invalidFields.push(field);
        }
        if (field.value !== '') {
            delete invalidFields[field];
            validFields.push(field);
        }
    });

    invalidFields.filter((field) => ['INPUT', 'SELECT'].indexOf(field.tagName) > -1).forEach((field) => {
        field.classList.add('invalid');
        const errorHint = field.parentElement.querySelector('.form__group__error')
        if (errorHint) {
            errorHint.innerHTML = 'Die Eingabe ist notwendig.';
        }
    })

    validFields.forEach((field) => {
        field.classList.remove('invalid')
        const errorHint = field.parentElement.querySelector('.form__group__error')
        if (errorHint) {
            errorHint.innerHTML = '';
        }
    })

    return invalidFields.length === 0;
}

const reset = (form) => {
    let attendeeTextFields = form.querySelectorAll('input[type=text].attendee-field,input[type=email].attendee-field,input[type=date].attendee-field,input[type=tel].attendee-field');
    let attendeeCheckboxFields = form.querySelectorAll('input[type=checkbox].attendee-field');
    let attendeeSelectBoxes = form.querySelectorAll('select.attendee-field');
    for (const attendeeField of attendeeTextFields) {
        attendeeField.value = '';
        attendeeField.classList.remove('invalid');
    }
    for (const attendeeField of attendeeCheckboxFields) {
        attendeeField.checked = false;
    }
    attendeeSelectBoxes.forEach((field) => {
        field.selectedIndex = 0;
        field.classList.remove('invalid');
    })
}

import Alpine from 'alpinejs'
document.addEventListener('alpine:init', () => {
    Alpine.data('eventRegistrationForm', (initialConfigJson => {
        const initialConfig = JSON.parse(initialConfigJson)
        return {
            nodePath: initialConfig.nodePath,
            isBusy: true,
            hasError: false,
            hasValidationErrors: false,
            validationErrorNotifications: [],
            // can be loading, open, signed-up or limit-reached
            state: 'loading',
            mode: initialConfig.mode || 'both',
            selectedForm: initialConfig.mode === 'both' ? 'single' : null,

            init() {
                fetch('/registration/currentstate?node=' + encodeURI(this.nodePath), {
                    credentials: 'include'
                })
                    .then(async (response) => {
                        const {limitReached, isSignedUp} = await response.json()
                        if (isSignedUp) {
                            this.state = 'signed-up'
                        } else if (limitReached) {
                            this.state = 'limit-reached'
                        } else {
                            this.state = 'open'
                        }
                    })
                    .finally(() => {
                        this.isBusy = false
                    })
            },

            get showFormSwitcher() {
                return !this.isBusy && this.state === 'open' && this.mode === 'both'
            },

            get showSingleForm() {
                return !this.isBusy && this.state === 'open' && (this.mode === 'single' || (this.mode === 'both' && this.selectedForm === 'single'))
            },

            get showGroupForm() {
                return !this.isBusy && this.state === 'open' && (this.mode === 'group' || (this.mode === 'both' && this.selectedForm === 'group'))
            },

            submitSingleRegistration() {
                const singleRegistrationForm = this.$root.querySelector('form.single_registration');

                if (!singleRegistrationForm) {
                    return;
                }

                const validationResult = this.validateForm(singleRegistrationForm);
                if (!validationResult.valid) {
                    this.hasValidationErrors = true
                    this.validationErrorNotifications = validationResult.notifications
                    return;
                }

                this.hasError = false
                this.hasValidationErrors = false
                this.isBusy = true
                fetch('/registration/createsingle', {
                    method: 'POST',
                    credentials: 'include',
                    body: new FormData(singleRegistrationForm)
                })
                    .then(async (response) => {
                        const {success, validationResults} = await response.json()
                        if (success === true) {
                            this.state = 'signed-up'
                            this.reset(singleRegistrationForm)
                        } else {
                            this.hasValidationErrors = true
                            Object.entries(validationResults).forEach(([key, propertyValidationResults]) => {
                                const fieldName = dotNotationToBracketNotation(key, false)
                                const element = singleRegistrationForm.querySelector(`[name="${fieldName}"]`)
                                element.classList.add('invalid')
                                const errorHintElement = element.parentElement.querySelector('span.form__group__error')
                                if (errorHintElement) {
                                    errorHintElement.innerText = propertyValidationResults.map(validationResult => validationResult.message).join('<br>')
                                }
                            })
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                        this.hasError = true
                    })
                    .finally(() => {
                        this.isBusy = false
                    })
            },

            submitGroupRegistration() {
                const groupRegistrationForm = this.$root.querySelector('form.group_registration');

                if (!groupRegistrationForm) {
                    return;
                }

                const validationResult = this.validateForm(groupRegistrationForm, true);
                if (!validationResult.valid) {
                    this.hasValidationErrors = true
                    this.validationErrorNotifications = validationResult.notifications
                    return;
                }

                this.hasError = false
                this.hasValidationErrors = false
                this.isBusy = true
                fetch('/registration/create', {
                    method: 'POST',
                    credentials: 'include',
                    body: new FormData(groupRegistrationForm)
                })
                    .then(async (response) => {
                        const {success, validationResults} = await response.json()
                        if (success === true) {
                            this.state = 'signed-up'
                            this.reset(groupRegistrationForm)
                        } else {
                            this.hasValidationErrors = true
                            Object.entries(validationResults).forEach(([key, propertyValidationResults]) => {
                                const fieldName = dotNotationToBracketNotation(key, false)
                                const element = groupRegistrationForm.querySelector(`[name="${fieldName}"]`)
                                element.classList.add('invalid')
                                const errorHintElement = element.parentElement.querySelector('span.form__group__error')
                                if (errorHintElement) {
                                    errorHintElement.innerText = propertyValidationResults.map(validationResult => validationResult.message).join('<br>')
                                }
                            })
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                        this.hasError = true
                    })
                    .finally(() => {
                        this.isBusy = false
                    })
            },

            reset,
            validateAttendee,
            validateForm,
            addAttendee
        }
    }))
})
